var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { staticStyle: { "margin-bottom": "15px" }, attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-card",
        { staticClass: "service-card max-width" },
        [
          _c(
            "v-card-title",
            { staticClass: "card-bg-4 py-2" },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-2",
                  attrs: {
                    large: "",
                    color: _vm.isActive ? "success" : "error",
                  },
                },
                [_vm._v(_vm._s(_vm.isActive ? "done" : "clear"))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.service.DisplayName)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card-text", [
            _c("div", [
              _vm._v("Base Url: " + _vm._s(_vm.service.BaseUrl) + " "),
            ]),
            _vm._v(" "),
            _vm.serviceLink
              ? _c(
                  "div",
                  [
                    _vm._v("\n        Service Link:\n        "),
                    _c("v-chip", { attrs: { small: "" } }, [
                      _vm._v(_vm._s(_vm.serviceLink)),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _vm.ServiceTypesWithConfigurations.has(_vm.service.ServiceType)
                ? _c(
                    "SecondaryBtn",
                    {
                      attrs: {
                        small: "",
                        icon: "settings",
                        disabled: !_vm.isActive || _vm.service.ServiceType == 1,
                        to: "/administration/manage_services/" + _vm.service.Id,
                      },
                    },
                    [_vm._v("\n        Tenant Configurations\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("ViewServiceLogsDialog", { attrs: { service: _vm.service } }),
              _vm._v(" "),
              _c("ViewServiceDialog", { attrs: { service: _vm.service } }),
              _vm._v(" "),
              _c("EditServiceDialog", { attrs: { service: _vm.service } }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }